/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupquestiontype2Inputs */

const en_signupquestiontype2 = /** @type {(inputs: Signupquestiontype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const de_signupquestiontype2 = /** @type {(inputs: Signupquestiontype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Art`)
};

/**
* | output |
* | --- |
* | "Type" |
*
* @param {Signupquestiontype2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupquestiontype2 = /** @type {((inputs?: Signupquestiontype2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupquestiontype2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupquestiontype2(inputs)
	return de_signupquestiontype2(inputs)
});
export { signupquestiontype2 as "signupQuestionType" }